//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Success',
  props: {
    done: {
      type: Boolean,
      default: false,
    },
    idealLink: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    headerImg: require('~/assets/img/lid-worden.jpg'),
  }),
};
